<div mat-dialog-header>
  <h1>Tech Notes</h1>
</div>
<div mat-dialog-content class="dialog-content">
  <div class="build-info-section">
    <app-build-information [modalView]="true" />
  </div>
</div>
<div class="buttons">
  <button type="button" mat-raised-button (click)="close()">Close</button>
</div>
